import {handleActions} from 'redux-actions';
import {LoadAction, CreateAction, UpdateAction, FormState} from './Types';

export const initialState: FormState = {
    item: {
        _id: '',
        name: '',
        devices: [],
    },
    isLoading: true,
    errors: {},
    saveCompleted: false,
};

export const setAppName = (state: FormState, action: LoadAction): FormState => {
    const {item} = action.payload;
    
    if (item) {
        return {
            ...state,
            item,
        };
    }
    
    return {
        ...initialState,
        isLoading: false,
        saveCompleted: false,
    };
};

const createAppName = (state: FormState, action: CreateAction): FormState => {
    const {item, errors} = action.payload;
    
    if (errors) {
        return {
            ...state,
            errors,
        };
    }
    
    return {
        ...state,
        item,
        saveCompleted: true,
        isLoading: false,
    };
};

const updateAppName = (state: FormState, action: UpdateAction): FormState => {
    const {item, errors} = action.payload;
    
    if (errors) {
        return {
            ...state,
            errors,
        };
    }
    
    return {
        ...state,
        item,
        saveCompleted: true,
        isLoading: false,
    };
};

const actionsHandler = handleActions(
    {
        LOAD: (state, action) => setAppName(state, action),
        CREATE: (state, action) => createAppName(state, action),
        UPDATE: (state, action) => updateAppName(state, action),
        CLEAN: () => initialState,
    },
    initialState,
);

export default actionsHandler;
